import(/* webpackMode: "eager" */ "/app/components/BuyNow/BuyNow.module.scss");
;
import(/* webpackMode: "eager" */ "/app/app/(main)/franchise/[slug]/FranchiseAboutTab/FranchiseAboutTab.module.scss");
;
import(/* webpackMode: "eager" */ "/app/components/Button/Button.module.scss");
;
import(/* webpackMode: "eager" */ "/app/components/ContentRowTitleDescription/ContentRowTitleDescription.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/FranchiseHero/FranchiseHero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/GTMPageView/GTMPageView.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/Highlight/Highlight.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/SponsorshipUnit/SponsorshipUnit.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/Tab/TabContainer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/Transitions/ModalPageTransition.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/VideoRow/VideoRow.module.scss");
;
import(/* webpackMode: "eager" */ "/app/components/ShowPoster/ShowPoster.module.scss");
;
import(/* webpackMode: "eager" */ "/app/components/ShowGrid/ShowGrid.module.scss");
;
import(/* webpackMode: "eager" */ "/app/app/(main)/franchise/[slug]/FranchiseShowsTab/FranchiseShowsTab.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/VideoRow/VideoThumbnailCarousel.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/public/svg/add.svg");
;
import(/* webpackMode: "eager" */ "/app/public/svg/amazon.svg");
;
import(/* webpackMode: "eager" */ "/app/public/svg/apple_tv.svg");
;
import(/* webpackMode: "eager" */ "/app/public/svg/check.svg");
;
import(/* webpackMode: "eager" */ "/app/public/svg/down.svg");
;
import(/* webpackMode: "eager" */ "/app/public/svg/download.svg");
;
import(/* webpackMode: "eager" */ "/app/public/svg/play.svg");
;
import(/* webpackMode: "eager" */ "/app/public/svg/shuffle.svg");
